module.exports = __webpack_public_path__ + "img/logo.6a04fcf2.png";